<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="$t('other.there_is_no_more')"
      :loading-text="$t('other.Loading')"
      @load="onLoadShopProductList"
    >
      <van-row>
        <van-col span="22" offset="1" v-for="(l) in list" :key="l.id">
          <img :src="l.bg_img" class="game_priture_list_bgimg"  @click="play(l)"/>
        </van-col>
      </van-row>
    </van-list>
  </div>
</template>

<script>
import axios from "axios";
import Toast from "vant/lib/toast"
import { judgeIosAndroid } from '@/assets/js/models.js'

export default {
  name: "shop_product_list",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,
      isLoading: false,
    }
  },
  created: function () {
    document.title = this.$t('title.shop_product');
  },
  methods: {
    play(item) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      let url = item.url
      url += (url.indexOf("?") == -1 ? "?" : "&"); //判断是否有问号
      url += 'uid='+ uid + '&token=' + token;
      //  拦截
      const isIos = judgeIosAndroid();
      if (isIos === true) {
        window.location.href= url
        // window.webkit.messageHandlers.play_game.postMessage(url)
      } else {
        // Android传值方法goSubmitted（val）传值方式
        window.AndroidJs.play_game(url)
      }
    },
    onLoadShopProductList: function () {
      this.page++;
      const token = this.$route.query.token;
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=room_game_list", {
        params: {
          token: token,
          page: this.page,
          start_time: this.gift_start_time,
          end_time: this.gift_end_time,
          type: 'h5'
        }
      }).then(res => {
        console.log(res.data);
        if (res.data.status === 0) {
          Toast(res.data.error);
          this.finished = true;
          return;
        }
        if (this.page === 1) {
          this.list = res.data.list;
        } else {
          this.list = this.list.concat(res.data.list)
        }

        // 加载状态结束
        this.loading = false;

        //数据全部加载完成
        if (res.data.list.length < 50) {
          this.finished = true;
        } else {
          this.finished = false;
        }

        this.isLoading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/game_picture_list.vue